import Select from 'components/core/Select'
import { ACCESSORIAL_OPTIONS } from 'constants/accessorial.constants'
import { AccessorialType } from 'types/accessorial.types'

type AccessorialSelectProps = {
    isDisabled?: boolean
    shouldPortalMenu?: boolean
    label?: string
    placeholder?: string
    error?: string
    menuPlacement?: 'auto' | 'bottom' | 'top'
    accessorials?: AccessorialType[] | null
    onChange: (accessorials: AccessorialType[]) => void
}

export const AccessorialSelect = ({
    isDisabled,
    shouldPortalMenu,
    label,
    placeholder,
    error,
    menuPlacement,
    accessorials,
    onChange,
}: AccessorialSelectProps) => {
    const _onChange = (accessorials: string[]) => {
        onChange(accessorials as AccessorialType[])
    }

    return (
        <Select
            isMulti
            shouldPortalMenu={shouldPortalMenu}
            isDisabled={isDisabled}
            label={label}
            error={error}
            placeholder={placeholder}
            menuPlacement={menuPlacement}
            value={accessorials ?? undefined}
            options={ACCESSORIAL_OPTIONS}
            onSelectedOptionChanged={_onChange}
        />
    )
}
